module.exports = __webpack_public_path__ + "static/img/info-message.2773260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info-message.svg
// module id = 452
// module chunks = 0